export const SURVOL_CONTOUR_DEFAUTS = Object.freeze ({
  couleur : "#1185c8",
  epaisseur : 4,
  opacite : 0.9,
});

export const SURVOL_CONTOUR_LIMITES = Object.freeze ({
  epaisseur : {min : 0, max : 48, step : 0.5},
  opacite : {min : 0, max : 1, step : 0.01},
});

function borne_nombre (pValeur, pMin, pMax, pDefaut)
  {
    const tBrut = Number (pValeur);
    const tNombre = Number.isFinite (tBrut) ? tBrut : pDefaut;
    return Math.max (pMin, Math.min (pMax, tNombre));
  }

function arrondit_nombre (pValeur, pPrecision = 2)
  {
    const tFacteur = Math.pow (10, Math.max (0, pPrecision | 0));
    return Math.round ((Number (pValeur) || 0) * tFacteur) / tFacteur;
  }

function normalise_couleur_hex (pValeur, pDefaut)
  {
    const tSource = typeof pValeur === "string" ? pValeur.trim ().toLowerCase () : "";
    const tDefaut = typeof pDefaut === "string" ? pDefaut.trim ().toLowerCase () : "#1185c8";
    if (/^#[0-9a-f]{6}$/.test (tSource)) return tSource;
    if (/^#[0-9a-f]{3}$/.test (tSource))
      return "#" + tSource.slice (1).split ("").map ((pCar) => pCar + pCar).join ("");
    return /^#[0-9a-f]{6}$/.test (tDefaut) ? tDefaut : "#1185c8";
  }

export function normalise_reglages_survol_contour_objet (pValeur, pDefauts = SURVOL_CONTOUR_DEFAUTS)
  {
    const tSource = pValeur && typeof pValeur === "object" && !Array.isArray (pValeur)
      ? pValeur
      : {};
    const tBase = {
      ...SURVOL_CONTOUR_DEFAUTS,
      ...(pDefauts && typeof pDefauts === "object" ? pDefauts : {}),
    };

    return {
      couleur : normalise_couleur_hex (tSource.couleur, tBase.couleur),
      epaisseur : arrondit_nombre (borne_nombre (
        tSource.epaisseur,
        SURVOL_CONTOUR_LIMITES.epaisseur.min,
        SURVOL_CONTOUR_LIMITES.epaisseur.max,
        tBase.epaisseur
      ), 2),
      opacite : arrondit_nombre (borne_nombre (
        tSource.opacite,
        SURVOL_CONTOUR_LIMITES.opacite.min,
        SURVOL_CONTOUR_LIMITES.opacite.max,
        tBase.opacite
      ), 3),
    };
  }

export function normalise_config_effets_survol_objet (pValeur)
  {
    const tSource = pValeur && typeof pValeur === "object" && !Array.isArray (pValeur)
      ? pValeur
      : {};
    return {
      survol_contour : normalise_reglages_survol_contour_objet (tSource.survol_contour),
    };
  }
